import {
  NAKSHATRA_LORDS,
  NAKSHATRA_NAMES,
  RASHI_NAMES,
  SIGN_LORDS,
  SIGN_NAMES,
  type NakshatraPosition,
  type Planet,
  type SignPosition,
} from '@astrally/shared';
import { norm360 } from '../math/angles.js';

export const NAKSHATRA_SPAN = 360 / 27; // 13°20'
export const PADA_SPAN = NAKSHATRA_SPAN / 4; // 3°20'

export function signOf(lon: number): number {
  return Math.floor(norm360(lon) / 30) % 12;
}

export function signPosition(lon: number): SignPosition {
  const l = norm360(lon);
  const sign = Math.floor(l / 30) % 12;
  return { sign, signName: SIGN_NAMES[sign], degInSign: l - sign * 30 };
}

export function rashiName(sign: number): string {
  return RASHI_NAMES[((sign % 12) + 12) % 12];
}

export function signName(sign: number): string {
  return SIGN_NAMES[((sign % 12) + 12) % 12];
}

export function nakshatraOf(lonSidereal: number): NakshatraPosition {
  const l = norm360(lonSidereal);
  const index = Math.floor(l / NAKSHATRA_SPAN) % 27;
  const within = l - index * NAKSHATRA_SPAN;
  const pada = (Math.floor(within / PADA_SPAN) + 1) as 1 | 2 | 3 | 4;
  return { index, name: NAKSHATRA_NAMES[index], pada, lord: NAKSHATRA_LORDS[index] };
}

export function signLord(sign: number): Planet {
  return SIGN_LORDS[((sign % 12) + 12) % 12];
}

/** Inclusive house-style count from sign a to sign b: same sign = 1, next = 2 ... */
export function signCount(fromSign: number, toSign: number): number {
  return ((toSign - fromSign + 12) % 12) + 1;
}
